import Swiper, { A11y, Autoplay, Keyboard, Navigation, Pagination } from 'swiper';

import '../../sass/blocks/client-links.scss';

( () => {
    const $clientLinks = document.querySelectorAll('.client-links');

    if ( !$clientLinks ) return;

    $clientLinks.forEach( $clientLink => {
        const $slider = $clientLink.querySelector('.client-links__slider');

        const initSlider = () => {
            if ( !$slider ) return;

            const $previous = $clientLink.querySelector('.client-links__slider-previous');
            const $next = $clientLink.querySelector('.client-links__slider-next');
            const $pagination = $clientLink.querySelector('.client-links__slider-pagination');

            const slider = new Swiper($slider, {
                modules: [ A11y, Autoplay, Keyboard, Navigation, Pagination ],
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                loop: true,
                a11y: {},
                keyboard: {
                    enabled: true,
                    onlyInViewport: false
                },
                navigation: $next && $previous ? {
                    nextEl: $next,
                    prevEl: $previous
                } : false,
                pagination: {
                    el: $pagination,
                    clickable: true
                },
            });
        };

        initSlider();
    } );
} )();
